import {} from '@chakra-ui/accordion'
import { Flex, Link, VStack } from '@chakra-ui/layout'
import { Divider, Text as ChakraText } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import {
  AiOutlineHighlight,
  AiOutlineQuestion,
  AiOutlineRead,
} from 'react-icons/ai'
import { HiOutlineChatAlt, HiOutlineChatAlt2 } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { colors } from '../../../../ui-kit'
import { UserContext } from '../../../providers'

const UsefulResources = (): React.ReactElement => {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)
  return (
    <VStack px={12} py={8} spacing="0.75em">
      <Flex direction="column" width="100%">
        <Flex>
          <AiOutlineRead fontSize="1.5em" />
          <ChakraText ml={1} fontWeight="600" mb={4}>
            {t('support_must_read_guides')}
          </ChakraText>
        </Flex>

        <Link
          isExternal
          href="https://imagekit.io/blog/lazy-loading-images-complete-guide/#"
        >
          {t('support_lazy_loading_images')}
        </Link>
        <Link
          isExternal
          href="https://imagekit.io/responsive-images/"
        >
          {t('support_responsive_images')}
        </Link>
        <Link
          isExternal
          href="https://imagekit.io/blog/how-to-use-imagekits-tools-and-analytics-to-perfectly-optimize-your-images/"
        >
          {t('support_performance_monitoring_and_analytics')}
        </Link>
      </Flex>
      <Divider orientation="horizontal" alignSelf="flex-start" />
      <Flex direction="column" width="100%">
        <Flex>
          <AiOutlineHighlight fontSize="1.5em" />
          <ChakraText ml={1} fontWeight="600" mb={4}>
            {t('support_feature_highlights')}
          </ChakraText>
        </Flex>

        <Link
          isExternal
          href="https://imagekit.io/blog/how-to-use-named-transformations-for-better-code-readability-and-maintenance/"
        >
          {t('support_named_transformation_info')}
        </Link>
        <Link
          isExternal
          href="https://imagekit.io/blog/smart-crop-deliver-perfect-responsive-images/"
        >
          {t('support_practical_application_of_smart_crop')}
        </Link>
      </Flex>
      <Divider orientation="horizontal" />
      <Flex direction="column" width="100%">
        <Flex>
          <AiOutlineQuestion fontSize="1.5em" />
          <ChakraText marginLeft={1} fontWeight="600" mb={4}>
            {t('support_get_help')}
          </ChakraText>
        </Flex>
        <Flex>
          <Link
            isExternal
            _hover={{ textDecoration: 'none' }}
            href="https://help.imagekit.io/en/"
            color={colors.appSlate}
            p={2}
            mr={8}
          >
            <Flex alignItems="center">
              <HiOutlineChatAlt fontSize="1.5em" />
              <ChakraText ml={1} fontWeight="600">
                {t('support_faqs')}
              </ChakraText>
            </Flex>
          </Link>

          <Link
            isExternal
            _hover={{ textDecoration: 'none' }}
            href="mailto:support@imagekit.io"
            color={colors.appSlate}
            p={2}
            mr={8}
          >
            <Flex alignItems="center">
              <MdOutlineMailOutline fontSize="1.5em" />
              <ChakraText ml={2} fontWeight="600">
                {t('support_email_support')}
              </ChakraText>
            </Flex>
          </Link>

          {user?.pricingPlan.isPaidPlan ? (
            <Link
              isExternal
              _hover={{ textDecoration: 'none' }}
              onClick={() => {
                window.Intercom('show')
              }}
              color={colors.appSlate}
              p={2}
              mr={8}
            >
              <Flex alignItems="center">
                <HiOutlineChatAlt2 fontSize="1.5em" />
                <ChakraText ml={2} fontWeight="600">
                  {t('support_chat_support')}
                </ChakraText>
              </Flex>
            </Link>
          ) : (
            <Link
              isExternal
              _hover={{ textDecoration: 'none' }}
              href="../upgrade-plan"
              color={colors.appSlate}
              p={2}
            >
              <Flex alignItems="center">
                <HiOutlineChatAlt2 fontSize="1.5em" />
                <ChakraText ml={2} fontWeight="600">
                  {t('support_chat_support_paid_plan_only')}
                </ChakraText>
              </Flex>
            </Link>
          )}
        </Flex>
      </Flex>
    </VStack>
  )
}

export default UsefulResources
